import { Box } from '@mui/system'
import { useQuery } from '@tanstack/react-query'
import { inject } from 'mobx-react'
import { observer } from 'mobx-react-lite'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import { queryClient } from '../../../../../App'
import RightDrawer from '../../../../../components/customElements/RightDrawer/RightDrawer'
import { isOperator } from '../../../../../services/AccountService'
import { getIncedentTypeReasons } from '../../../../../services/NewApiService'
import { isModalOpen } from '../../../../../utils/controllers/ModalController'
import AddServiceRequestForm from './AddServiceRequestForm'
import DrawerButtons from './DrawerButtons'
import FormsOnTop from './FormsOnTop'
import SearchResult from './SearchResult'
import WarningsContainer from './WarningsContainer'

const CreatingServiceRequestDrawer = ({ serviceStore }) => {
  const {
    onCloseDrawer,
    showAddServiceRequestForm,
    showRequestPreview,
    serviceAddRequestFormStore: { data: formData },
  } = serviceStore

  const { data: incedentTypeReasons, isLoading: isIncedentsLoading } = useQuery(
    {
      queryKey: ['incedent-type-reasons'],
      queryFn: () => getIncedentTypeReasons(),
      enabled: () => isOperator(),
      staleTime: 1000000,
      placeholderData: [],
    },
    queryClient,
  )

  const subscriberReason = incedentTypeReasons?.find(
    (reason) => reason.name === formData.malfunctionTypeId,
  )
  const isOpen = isModalOpen['create-service-request']
  const closeWithConfirmation = showAddServiceRequestForm || showRequestPreview

  return (
    <RightDrawer
      open={isOpen}
      onClose={() => onCloseDrawer(closeWithConfirmation)}
      title={<FormattedMessage id={'Заявка на сервисное обслуживание'} />}
      backButtonClick={() => onCloseDrawer(closeWithConfirmation)}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          height: '100%',
        }}
      >
        <Box>
          {isOpen && (
            <FormsOnTop
              isIncedentsLoading={isIncedentsLoading}
              incedentTypeReasons={incedentTypeReasons}
              subscriberReason={subscriberReason}
            />
          )}
          <AddServiceRequestForm />
          <SearchResult />
          {isOpen && <WarningsContainer />}
        </Box>
        <DrawerButtons subscriberReason={subscriberReason} />
      </Box>
    </RightDrawer>
  )
}

export default inject('serviceStore')(observer(CreatingServiceRequestDrawer))
